import React, { useEffect, useState } from 'react';
import { SORTING_DIRECTION_ASC, SORTING_DIRECTION_DESC } from '../../constant';
import { SortIcon } from '../../appearence/icons/sort_icon';
import { preferencesPhrasesStorage } from '../../services/preferencesPhrasesStorage';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const SortingDirectionIcon = () => {
    const [direction, setDirection] = useState('');
    const changeSortingDirection = () => {
        const direction  = preferencesPhrasesStorage.getSortingDirection() === SORTING_DIRECTION_ASC ? 
            SORTING_DIRECTION_DESC 
            : 
            SORTING_DIRECTION_ASC;
        setDirection(direction);
        preferencesPhrasesStorage.changeSortingDirection(direction);
    };

    const changeDirectionOfSorting = () => {
        setDirection(preferencesPhrasesStorage.getSortingDirection());
    };

    useEffect(() => {
        preferencesPhrasesStorage.registerFiltersChangingObserver(changeDirectionOfSorting);
        return () => preferencesPhrasesStorage.unRegisterFiltersChangingObserver(changeDirectionOfSorting);
    }, []);

    return (
        <IconWrapper handleClick={changeSortingDirection}>
                <SortIcon/>
        </IconWrapper>
    );
};

export default SortingDirectionIcon;
